export default "/_next/static/chunks/fonts/Montserrat Light-62e78d3423c42378ec006dbc2d83504d.otf";